"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconPinned = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "12.7542749 9.38676552 14.5459415 11.0209728 14.5459415 12.294381 10.1709415 12.294381 10.1709415 17.4092374 9.54594155 18.0459415 8.92094155 17.4092374 8.92094155 12.294381 4.54594155 12.294381 4.54594155 11.0209728 6.21260821 9.38676552 6.21260821 2.31934979 5.17094155 2.31934979 5.17094155 1.04594155 13.7959415 1.04594155 13.7959415 2.31934979 12.7542749 2.31934979"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconPinned')(IconPinned);